<template>
  <div class="home">
    <el-container style="height: 100%">
      <el-header class="topNav">
        <h1 class="site-navbar__brand" @click="$.push({ name: 'home' })">
          <a class="site-navbar__brand-lg" href="javascript:;">
            <img src="../assets/img/homeLogo.png" />
          </a>
        </h1>
        <!-- <p class="desc">让教学更轻松</p> -->
        <p class="title01">统一门户平台</p>
        <div class="personal">
          <el-dropdown :show-timeout="0" size="small" placement="bottom" >
            <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
              <div class="user_img">
                <img v-if="userImg && userImg != 'null'"
                     :src="userImg | fastImg"
                     style="height: 36px; border-radius: 50% 50%"/>
                <img
                  v-else
                  style="height: 36px"
                  src="../assets/img/default-header.png"
                  :alt="userName"
                />
              </div>
              <span style="color: #333;margin-left: 10px">{{ userName }}</span>
            </div>

            <el-dropdown-menu slot="dropdown" style="width: 110px">
              <el-dropdown-item @click.native="userMessage()">个人信息</el-dropdown-item>
              <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <div class="banner">
        <div class="search">
          <el-input v-model="key" class="txtsearch"></el-input>
          <el-button type="primary" class="btnsearch" @click="getHelpList">搜索</el-button>
        </div>
      </div>
      <div class="content">
        <div class="center1">
          <div class="content_left">
            <div class="title02">常见问题</div>
            <div class="leftList">
              <div v-for="(item,index) in helpTypeList" class="leftTitle" :class="index === chooseTypeIndex?'on':''" @click="changeType(item,index)">{{item.name}}</div>
            </div>
          </div>
          <div class="content_right">
            <div class="title03">全部列表<span v-if="show"><font>></font>{{helpTypeName}}</span></div>
            <div class="listRight"  v-if="!show">
              <div class="list" v-for="item in helpList" @click="openView(item)">
                <div class="left">{{item.title}}</div>
              </div>
              <div class="page">
                <el-pagination
                  layout="total, prev, pager, next"
                  @current-change="handleCurrentChange"
                  :total="pageTotal">
                </el-pagination>
              </div>
            </div>
            <helpView ref="helpView" v-else-if="show"></helpView>
          </div>
        </div>
        <el-footer class="footer">
          <span>版权所有 · 河南恩久信息科技有限公司</span>
          <span>服务热线：0371-55367299</span>
          <span>豫ICP备16019446号</span>
        </el-footer>
      </div>
      <!-- <el-main class="content">

      </el-main> -->

    </el-container>
    <!-- -->
  </div>
</template>

<script>
import Vue from "vue";
import { loginOut, listApplication, bindingPcWechat,getHelpTypeList,getHelpPage } from "@/api/api";
import { clearLoginInfo } from "@/utils";
import wxlogin from "vue-wxlogin";
import helpView from './components/view'
export default {
  data() {
    return {
      key:'',
      chooseTypeIndex:0,
      imgUrl: process.env.IMG_SHOW_URL + "/",
      helpTypeId:null,
      helpTypeName:null,
      userImg: this.$cookie.get("headImg"),
      userName: this.$cookie.get("name"),
      typeLists: ["全部"],
      typeName: "全部",
      typeIndex: 0,
      title: "",
      appLists: [],
      allApplication: [],
      code: "",
      wxConfig: {
        appid: process.env.WX_APPID,
        redirect_uri: "http://jbzk.ejkj.top/home?returnType=binding",
        wxVisible: false,
      },
      helpTypeList:[],
      pageTotal:20,
      pageNo:1,
      pageSize:10,
      show:false,
      helpList:[],
    };
  },
  mounted() {
    this.listApplication();
    const openid = this.$cookie.get("pcOpenid");
    const loginCount = this.$cookie.get("loginCount");
    if (typeof this.$route.query.returnType != "undefined") {
      let returnType = this.$route.query.returnType;
      this.code = this.$route.query.code;
      if (returnType == "binding") {
        //微信绑定
        this.bindingPcWechat();
      }
    }
    this.getHelpTypeList()
  },
  components: {
    wxlogin,
    helpView
  },
  methods: {
    changeType(item,index){
      this.helpTypeId = item.id
      this.helpTypeName = item.name
      this.chooseTypeIndex = index
      this.show = false
      this.getHelpList()
    },
    getHelpTypeList(){
      getHelpTypeList({}).then((res) => {
        if (res && res.code === 0) {
          this.helpTypeList = res.data
          if(this.helpTypeList){
            this.helpTypeId = this.helpTypeList[0].id
            this.helpTypeName = this.helpTypeList[0].name
            this.chooseTypeIndex = 0
            this.getHelpList()
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getHelpList(){
      let param = {
        'page':this.pageNo,
        'limit':this.pageSize,
        'typeId':this.helpTypeId,
        'key':this.key,
      }
      getHelpPage(param).then((res) => {
        if (res && res.code === 0) {
          this.helpList = res.data.list
          this.pageTotal = res.data.totalCount
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    openView(item){
      this.show = true
      this.$nextTick(() => this.$refs.helpView.init(item))
    },
    bindingPcWechat() {
      bindingPcWechat({
        code: this.code,
        userId: this.$cookie.get("userId"),
      }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success("微信绑定成功");
          this.$cookie.set("pcOpenid", res.data);
          this.wxConfig.wxVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    logoutHandle() {
      loginOut({
        token: this.$cookie.get("token"),
      }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success("退出登录成功");
          clearLoginInfo();
          this.$router.push({ path: "/login" });
        } else {
          //this.$message.error(res.msg);
          this.$message.success("退出登录成功");
          clearLoginInfo();
          this.$router.push({ path: "/login" });

        }
      });
    },
    userMessage() {
      this.$router.push({ path: "/personal" });
    },
    changeApp(index) {
      this.typeIndex = index;
      this.typeName = this.typeLists[this.typeIndex];
      this.searchApplication();
    },
    listApplication() {
      listApplication({}).then((res) => {
        if (res && res.code === 0) {
          this.allApplication = res.data;
          this.searchApplication();

          this.typeLists = ["全部"];
          this.allApplication.forEach((element) => {
            var isExist = false;
            this.typeLists.forEach((data) => {
              if (data == element.category) {
                isExist = true;
              }
            });
            if (!isExist) {
              this.typeLists.push(element.category);
            }
          });
        } else {
          this.$message.error(res.msg);
          this.$router.push({ path: '/login' })
        }
      });
    },
    searchApplication() {
      if (this.typeName === "全部") {
        this.appLists = this.allApplication;
      } else {
        this.appLists = this.allApplication.filter((item) => {
          return item.category === this.typeName;
        });
      }
    },
    searchApplicationByName() {
      this.searchApplication();
      if (this.title != "") {
        this.appLists = this.appLists.filter((item) => {
          return item.name.indexOf(this.title) >= 0;
        });
      }
    },

    onApplication(url) {
      console.log("[application] route", this.$route);
      console.log("[application] href", window.location.href);
      console.log("[application] router", this.$router);
      console.log("[application]", url);

      window.location.href = url + "?token=" + Vue.cookie.get("token");
    },
    openHelp(){
      this.$router.push({ path: '/helpCenter' })
    },
    //分页-
    handleCurrentChange(val) {
      this.pageNo = val
      this.getHelpList()
    },
  },
};
</script>

<style scoped lang="scss">
.search{
  display: flex;
  flex-direction: row;
  position: relative;
  top:230px;
  width: 1280px;
  margin: 0 auto;
  .txtsearch{
    margin-left: 150px;
    width: 360px;
  }
  .btnsearch{
    padding: 0 20px;
  }
}
.xuanfu{
  width: 50px;
  height: 50px;
  position: fixed;
  right: 0px;
  bottom: 40px;
  font-size: 0;
  z-index: 9999999;
}
.xuanfu img{
  width: 50px;
  cursor: pointer;
}
.bztext{
  position: absolute;
  right: 50px;
  bottom: -15px;
  width: 120px;
  color: #333;
  z-index: 99;
  height: 50px;
  font-size: 16px;
  display: none;
}
.xuanfu:hover .bztext{
  display: block;
}
.banner {
  text-align: center;
  background: url("../assets/img/b1.png") no-repeat center center;
  width: 100%;
  height: 350px;
  text-align: center;
  overflow: hidden;
}
.user_img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  line-height: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
* {
  margin: 0;
  padding: 0;
}
.home {
  //height: 940px;
  background: #F3F6F9;
  .topNav {
    position: relative;
    height: 70px!important;
    padding-top: 16px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    .site-navbar__brand {
      margin-left: 47px;
    }
    .desc {
      margin-left: 19px;
      margin-top: 16px;
      color:#333;
    }
    .title01 {
      color: #333;
      margin-left: 52px;
      margin-top: 6px;
      font-weight: 400;
      font-size: 20px;
    }
    .personal {
      position: absolute;
      right: 45px;
      top: 7px;
      color: #333;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
      .el-dropdown-link {
        width: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
      }
    }
  }

  .content {
    width: 100%;
    position: absolute;
    top:420px;
    // background: #f3f6f9;
    .center1 {
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 60px;
      width: 1280px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      min-height: 500px;
      .content_left{
        width: 320px;
        text-align: left;
        background: #fff;
        background: rgba(255, 255, 255, 0.39);box-shadow: 0px 3px 6px rgba(60, 148, 237, 0.2);
        .title02{
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 21px;
          color: #333333;
          border-bottom: 1px solid #DDDDDD;
          padding: 15px 26px;
        }
        .leftList{
          display: flex;
          flex-direction: column;
          .leftTitle{
            border-bottom: 1px solid #DDDDDD;
            padding: 15px 26px;
            cursor: pointer;
          }
          .on{
            background: rgba(47, 70, 222, 0.1);
            color: #3C94ED;
          }
        }
      }
      .content_right{
        width: 940px;
        text-align: left;
        background: #fff;
        background: rgba(255, 255, 255, 0.39);box-shadow: 0px 3px 6px rgba(60, 148, 237, 0.2);
        .title03{
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 21px;
          color: #333333;
          border-bottom: 1px solid #DDDDDD;
          padding: 15px 26px;
        }
        .listRight{
          display: flex;
          flex-direction: column;
          padding: 0 20px;
          .list{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 1px  #DDDDDD dotted;
            padding: 15px 0;
            .left{
              flex: 1;
              cursor: pointer;
            }
            .right{
              width: 100px;
              color: #999999;
              span{
                color: #666666;
              }
            }
          }
          .page{
            padding: 15px 0;
            float: right;
            text-align: right;
          }
        }
      }
    }
    .center {
      margin: 0 auto;
      margin-top: 20px;
      width: 1280px;
      // height: 800px;
      background: #fff;
      box-shadow: 0px 3px 6px rgba(60, 148, 237, 0.2);
      opacity: 1;
      border-radius: 5px;
      .topTitle {
        height: 80px;
        border-bottom: solid 1px #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          width: 100px;
          margin-left: 38px;
          font-family: Microsoft YaHei;
          font-weight: 400;
        }
        .selectKey {
          width: 300px;
          margin-right: 40px;
          .curson {
            margin-top: 10px;
          }
        }
      }
      .appTypes {
        margin: 24px 0;
        height: 40px;
        p {
          width: 100px;
          font-weight: bold;
          float: left;
          margin-left: 64px;
          height: 40px;
          line-height: 40px;
        }
        ul {
          float: left;
          list-style: none;
        }
        .nametype {
          li {
            float: left;
            width: 100px;
            height: 40px;
            line-height: 40px;
            border-radius: 30px;
            cursor: pointer;
          }
          .activeClass {
            background: linear-gradient(180deg, #6eb7ff 0%, #606dff 100%);
            color: white;
          }
        }
      }
      .apps {
        padding-left: 64px;
        padding-top: 15px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        dl {
          width: 90px;
          height: 130px;
          margin-right: 108px;
          margin-bottom: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          img {
            width: 90px;
            height: 90px;
            border-radius: 20px;
          }
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0px;
    height: 35px !important;
    background-color: #151617;
    text-align: center;
    color: #ffffff;
    width: 100%;
    line-height: 35px;
    span {
      margin-right: 15px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/helpCenter.vue